import './register.scss';
import React from 'react';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import { login } from 'app/shared/util/utilities';
import { IRootState } from 'app/shared/reducers';
import { RouteComponentProps } from 'react-router';

export interface ISuccessPageProps extends StateProps, DispatchProps, RouteComponentProps<{}> {}

export interface ISuccessPageState {
  redirectLogin: boolean;
}

export class SuccessPage extends React.Component<ISuccessPageProps, ISuccessPageState> {
  state: ISuccessPageState = {
    redirectLogin: false
  };

  componentDidMount = () => {
    if (window['is_mobile']()) {
      let timerId = setTimeout(() => {
        login(this.props.location.state.config);
      }, 3000);
    }
  };

  handleClick = () => {
    this.setState({
      redirectLogin: true
    });
  };
  render() {
    if (this.state.redirectLogin) {
      login(this.props.location.state.config);
    }
    return (
      <div className="box-success justify-content-center" onClick={this.handleClick}>
        <img src={require('app/images/ic_tick.png')} alt="" />
        <p className="text-center">{this.props.location.state.message ? this.props.location.state.message : 'Đăng ký thành công!'}</p>
      </div>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({
  // currentLocale: storeState.locale.currentLocale,
  // config: storeState.applicationProfile.config,
});

const mapDispatchToProps = {};
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SuccessPage);
